import { MessageBarType, Stack, Text } from "@fluentui/react";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { containerStyles, formContainerStyles, lgContainerStyles, lgSubTitleStyles, lgTitleContainerStyles, lgTitleStyles, mdContainerStyles, mdSubTitleStyles, mdTitleContainerStyles, mdTitleStyles, smContainerStyles, smSubTitleStyles, smTitleContainerStyles, smTitleStyles, subTitleStyles, titleContainerStyles, titleStyles, xlContainerStyles, xlSubTitleStyles, xlTitleContainerStyles, xlTitleStyles, xxlContainerStyles, xxlSubTitleStyles, xxlTitleContainerStyles, xxlTitleStyles } from "../Common/Styles/CommonStyles";
import { RegisterConfigurationAppList } from "./Components/RegisterConfigurationAppList";
import { IRegisterContext, useRegisterContext } from "../../RegisterContainer";
import { RegisterMessageBar } from "../Common/RegisterErrorBar";
import { RegisterService } from "../../Service/RegisterService";

export const RegisterConfiguration: React.FC = () => {
    const registerContext: IRegisterContext = useRegisterContext();
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack
            className={
                isSM ? 
                    smContainerStyles : 
                isMD ? 
                    mdContainerStyles :
                isLG ?
                    lgContainerStyles :
                isXL ?
                    xlContainerStyles :
                isXXL ?
                    xxlContainerStyles
                :
                    containerStyles
            }
        >
            <Stack
                className={
                    isSM ? 
                        smTitleContainerStyles : 
                    isMD ? 
                        mdTitleContainerStyles :
                    isLG ?
                        lgTitleContainerStyles :
                    isXL ?
                        xlTitleContainerStyles :
                    isXXL ?
                        xxlTitleContainerStyles
                    :
                        titleContainerStyles
                }
            >
                <Text 
                    className={
                        isSM ? 
                            smTitleStyles : 
                        isMD ? 
                            mdTitleStyles : 
                        isLG ?
                            lgTitleStyles :
                        isXL ?
                            xlTitleStyles :
                        isXXL ?
                            xxlTitleStyles
                        :
                            titleStyles
                    }
                >
                    {RegisterService.translate("configuration:title")}
                </Text>
                <Text 
                    className={
                        isSM ? 
                            smSubTitleStyles : 
                        isMD ? 
                            mdSubTitleStyles :
                        isLG ?
                            lgSubTitleStyles :
                        isXL ?
                            xlSubTitleStyles :
                        isXXL ?
                            xxlSubTitleStyles
                        :
                            subTitleStyles
                    }
                >
                    {RegisterService.translate("configuration:description")}
                </Text>
            </Stack>
            <Stack
                className={formContainerStyles}
            >
                <RegisterMessageBar
                    visible={registerContext.registerError.hasError}
                    type={MessageBarType.error}
                    message={RegisterService.getErrorMessage(registerContext.registerError)}
                />
                <RegisterConfigurationAppList />
            </Stack>
        </Stack>
    );
};